import { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { UserContext } from "../context/user";
import { T } from "react-translator-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobile } from "@fortawesome/free-solid-svg-icons";

const AddToHomeScreen = () => {
    const { language } = useContext(UserContext);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const isAndroid = /android/i.test(navigator.userAgent);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);


        return () => {
            window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        };
    }, []);

    const handleAddToHomeScreenInstructions = () => {
        if (isAndroid && deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === "accepted") {
                    console.log("El usuario aceptó agregar a la pantalla de inicio");
                } else {
                    console.log("El usuario rechazó agregar a la pantalla de inicio");
                }
                setDeferredPrompt(null);
            });
        } else {
            const lang = language.split('-')[0];
            window.AddToHomeScreenInstance.show(lang);
     
        }
    };

    return (
        <div className="text-center">
            <FontAwesomeIcon icon={faMobile} style={{ fontSize: 55, color: '#007bff' }} className="mb-2" />
            <p className="mt-3">
                {T("general.add-to-home-screen-text")}
            </p>
            <Button
                style={{ minWidth: '80%' }}
                size={'lg'}
                variant={'primary'}
                type={'button'}
                className="text-uppercase"
                onClick={handleAddToHomeScreenInstructions}
            >
                {T("general.add-to-home-screen-button")}
            </Button>
        </div>
    );
};

export default AddToHomeScreen;
